"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = void 0;
var Parser = /** @class */function () {
  function Parser(options) {
    var sourceTable = {};
    if (options.sourceTable.length < 1) {
      return null;
    }
    // Source
    for (var lineId = 1; lineId < options.sourceTable.length; lineId++) {
      for (var lc = 1; lc < options.sourceTable[0].length; lc++) {
        var line = options.sourceTable[lineId];
        var code = options.sourceTable[0][lc].toLowerCase();
        if (!sourceTable[code]) {
          sourceTable[code] = {};
        }
        sourceTable[code][line[0]] = line[lc];
      }
    }
    this.sourceTable = sourceTable;
    // Declensions
    if (options.declensionTable) {
      var startCol = 3;
      var startRow = 1;
      var declensionTable = {};
      for (var lineId = startRow; lineId < options.declensionTable.length; lineId++) {
        for (var lc = startCol; lc < options.declensionTable[0].length; lc++) {
          var line = options.declensionTable[lineId];
          var code = options.declensionTable[0][lc].toLowerCase();
          if (!declensionTable[code]) {
            declensionTable[code] = {};
          }
          var key = Parser.getBracedWord(line[startRow + 1], Parser.PLAIN_TEXT_WRAPPER_START, Parser.PLAIN_TEXT_WRAPPER_END).word;
          declensionTable[code][key] = line[lc];
        }
      }
      this.declensionTable = declensionTable;
    }
    return this;
  }
  Parser.prototype.parse = function (line, locale_code, discipline_code, reversed) {
    if (reversed === void 0) {
      reversed = false;
    }
    if (!line || line.length < 1) {
      return line;
    }
    // LOGIC: https://app.clickup.com/t/6pr6um?comment=74001763
    line = this.translateLanguageString(line, reversed ? discipline_code : locale_code);
    var bracedWord = null;
    // Locale
    if (locale_code) {
      var wrapper = Parser.LOCALE_WRAPPER;
      bracedWord = Parser.getBracedWord(line, wrapper).word;
      while (bracedWord) {
        var translatedBraced = this.translateLanguageString(bracedWord, locale_code);
        line = Parser.replaceBracedWord(line, bracedWord, translatedBraced, wrapper);
        bracedWord = Parser.getBracedWord(line, wrapper).word;
      }
    }
    // Discipline
    if (discipline_code) {
      var wrapper = Parser.DISCIPLINE_WRAPPER;
      bracedWord = Parser.getBracedWord(line, wrapper).word;
      while (bracedWord) {
        var translatedBraced = this.translateLanguageString(bracedWord, discipline_code);
        line = Parser.replaceBracedWord(line, bracedWord, translatedBraced, wrapper);
        bracedWord = Parser.getBracedWord(line, wrapper).word;
      }
    }
    // Declensions
    if (this.declensionTable) {
      var wrapper = Parser.DECLENSION_WRAPPER;
      var bracedData = Parser.getBracedWord(line, wrapper);
      while (bracedData.word) {
        var translatedBraced = this.translateLanguageString(bracedData.word, discipline_code, this.declensionTable, true);
        var position = bracedData.position;
        if (translatedBraced) {
          line = Parser.replaceBracedWord(line, bracedData.word, translatedBraced, wrapper);
          position += translatedBraced.length - (bracedData.word.length + 2 * Parser.DECLENSION_WRAPPER.length);
        }
        bracedData = Parser.getBracedWord(line, wrapper, wrapper, position);
      }
    }
    // Cleanup [[[ ]]]
    bracedWord = Parser.getBracedWord(line, '[[[', ']]]').word;
    while (bracedWord) {
      line = Parser.replaceBracedWord(line, bracedWord, bracedWord, '[[[', ']]]');
      bracedWord = Parser.getBracedWord(line, '[[[', ']]]').word;
    }
    // console.log(line);
    return line;
  };
  Parser.verify = function (line) {
    if (!line) {
      return true;
    }
    return !line.match(/(\@\@)|(\[\[)|(\]\])|(\%\%)/gi);
  };
  Parser.getBracedWord = function (line, braces_start, braces_end, position) {
    var result = {
      word: null,
      position: -1
    };
    if (!braces_end) {
      braces_end = braces_start;
    }
    var startsFrom = line.indexOf(braces_start, position);
    if (startsFrom > -1 && line[startsFrom + braces_start.length] !== braces_start[0]) {
      startsFrom += braces_start.length;
      var endsAt = line.indexOf(braces_end, startsFrom);
      if (endsAt > -1) {
        result.word = line.substring(startsFrom, endsAt);
        result.position = endsAt + braces_end.length + 1;
      }
    }
    return result;
  };
  Parser.replaceBracedWord = function (line, search, replace, braces_start, braces_end) {
    if (!braces_end) {
      braces_end = braces_start;
    }
    if (!replace || replace.length === 0) {
      replace = search;
    }
    return line.replace("".concat(braces_start).concat(search).concat(braces_end), replace);
  };
  Parser.prototype.translateLanguageString = function (line, language_code, table, dontUseDefault) {
    if (dontUseDefault === void 0) {
      dontUseDefault = false;
    }
    language_code = language_code.toLowerCase();
    if (!table) {
      table = this.sourceTable;
    }
    if (table && table[language_code] && table[language_code][line]) {
      return table[language_code][line];
    }
    return dontUseDefault ? '' : line;
  };
  Parser.LOCALE_WRAPPER = '%%';
  Parser.DISCIPLINE_WRAPPER = '%%%';
  Parser.DECLENSION_WRAPPER = '@@';
  Parser.PLAIN_TEXT_WRAPPER_START = '[[[';
  Parser.PLAIN_TEXT_WRAPPER_END = ']]]';
  return Parser;
}();
exports.Parser = Parser;
